/**
 * Canonical Storage read paths for design-board previews (client).
 * Keep in sync with functions/main/projectDesignBoardFileReadPathModel.js.
 */

import {
  buildVersionedPmProjectFileObjectPath,
} from "./projectFileAuthenticatedBlob";
import {
  isExplicitPmProjectFileStoragePath,
  isVersionedPmProjectFileStoragePath,
} from "./projectFileSecureStorageModel";

function safeStr(value) {
  return String(value ?? "").trim();
}

export { isExplicitPmProjectFileStoragePath } from "./projectFileSecureStorageModel";

export function resolveCanonicalPmProjectFileStoragePath(fileRecord = {}) {
  const direct = safeStr(fileRecord.storagePath || fileRecord.storageOriginalPath);
  if (direct) return direct;
  const fromPath = safeStr(fileRecord.path || fileRecord.fullPath);
  if (fromPath && isExplicitPmProjectFileStoragePath(fromPath)) return fromPath;
  return "";
}

export function resolvePmProjectFileReadStoragePath(
  fileRecord = {},
  { projectId = "", fileId = "", objectKind = "original" } = {}
) {
  const kind = safeStr(objectKind) === "thumbnail" ? "thumbnail" : "original";
  const pid = safeStr(projectId || fileRecord.projectId);
  const fid = safeStr(fileId || fileRecord.fileId || fileRecord.id);

  if (kind === "thumbnail") {
    const thumb = safeStr(fileRecord.thumbnailStoragePath || fileRecord.thumbnailPath);
    if (thumb) return thumb;
    const originalPath = resolvePmProjectFileReadStoragePath(fileRecord, {
      projectId: pid,
      fileId: fid,
      objectKind: "original",
    });
    if (isVersionedPmProjectFileStoragePath(originalPath) && pid && fid) {
      return buildVersionedPmProjectFileObjectPath(pid, fid, "thumbnail");
    }
    return "";
  }

  const canonical = resolveCanonicalPmProjectFileStoragePath(fileRecord);
  if (canonical) return canonical;

  if (fileRecord.designBoardUpload === true && pid && fid) {
    return buildVersionedPmProjectFileObjectPath(pid, fid, "original");
  }
  if (safeStr(fileRecord.storageAuthDomain) === "procurement_order_attachment" && pid && fid) {
    return buildVersionedPmProjectFileObjectPath(pid, fid, "original");
  }
  return "";
}
